export default {
  modelName: 'article',
  versionModelName: 'article_version',
  versionTimestampKey: 'announce_at',
  label: '法條',
  fields: {
    chapter: {
      type: 'text',
      label: '章節文字',
      textKey: 'chapter',
      sm: 6,
      maxlength: 20,
      isValueComparable: true,
    },
    no_text: {
      type: 'text',
      label: '條文文字',
      textKey: 'no_text',
      width: '300px',
      isValueComparable: true,
    },
    content: {
      type: 'textarea',
      label: '法條內容',
      textKey: 'content',
      rules: 'required',
      maxlength: 50000,
      isValueComparable: true,
    },
    rich_content: {
      type: 'editor',
      label: '法條內容 (含HTML)',
      textKey: 'rich_content',
      maxlength: 50000,
      isValueComparable: true,
    },
    official_comment: {
      type: 'textarea',
      label: '立法理由',
      textKey: 'official_comment',
      maxlength: 10000,
      isValueComparable: true,
    },
    no_number: {
      type: 'text',
      label: '條文數字',
      textKey: 'no_number',
      sm: 12,
      rules: 'required',
      maxlength: 10,
      isValueComparable: true,
    },
    announce_at: {
      type: 'date',
      label: '發布日期',
      maxlength: 100,
      sm: 6,
      isValueComparable: true,
    },
    effect_at: {
      type: 'date',
      label: '生效日期',
      rules: 'required',
      maxlength: 100,
      sm: 6,
      isValueComparable: true,
    },
    attaches: {
      type: 'files',
      label: '附件',
      textKey: 'attaches',
      uploadUrl: '/article_version/attach/',
      isValueComparable: true,
    },
    reference_link: {
      type: 'link',
      label: '來源連結',
      textKey: 'reference_link',
      maxlength: 500,
      isValueComparable: true,
    },
    ll_comment: {
      type: 'textarea',
      label: 'ESGoal評析',
      maxlength: 10000,
      isValueUpdatable: true,
      isValueComparable: true,
    },
    effects: {
      label: '風險燈號',
      type: 'hasMany',
      modelName: 'effect',
      textKey: 'name',
      isValueUpdatable: true,
      isValueComparable: true,
      conditionKeys: [
        {
          fieldName: 'areas',
          conditionName: 'area',
          type: 'array',
        },
      ],
    },
    icon: {
      label: '更新版本',
      type: 'custom',
      getValue: function(item){
        return item.act_version.id === item.act_versions[0].id ? 'mdi-check' : null;
      }
    },
    isInRowBtnCheckPassDisabled: {
      type: 'custom',
      getValue: function(item){
        if (item.act_version.id === item.act_versions[0].id){
          return false
        } else {
          return true
        }
      }
    },
    isInRowBtnCheckFailDisabled: {
      type: 'custom',
      getValue: function(item){
        if (item.act_version.id === item.act_versions[0].id){
          return false
        } else {
          return true
        }
      }
    },
    isInRowBtnUpdateDisabled: {
      type: 'custom',
      getValue: function(item){
        if (item.act_version.id === item.act_versions[0].id){
          return false
        } else {
          return true
        }
      }
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後編輯者',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    updated_at: {
      type: 'datetime',
      label: '最後編輯時間',
      readonly: true,
    },
    act_cnt_updated_at: {
      type: 'datetime',
      label: '格式更新編輯時間',
      readonly: true,
    },
    act_cnt_updated_admin: {
      type: 'belongsTo',
      label: '格式更新編輯者',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    act_cnt_final_reviewed_at: {
      type: 'datetime',
      label: '格式更新覆核編輯時間',
      readonly: true,
    },
    act_cnt_final_reviewer: {
      type: 'belongsTo',
      label: '格式更新覆核編輯者',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    idtf_updated_at: {
      type: 'datetime',
      label: '鑑別編輯時間',
      readonly: true,
    },
    idtf_updated_admin: {
      type: 'belongsTo',
      label: '鑑別編輯者',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    idtf_final_reviewed_at: {
      type: 'datetime',
      label: '鑑別覆核編輯時間',
      readonly: true,
    },
    idtf_final_reviewer: {
      type: 'belongsTo',
      label: '鑑別覆核編輯者',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    act_cnt_check_result: {
      type: 'text',
      label: '格式更新結果',
      readonly: true,
      getText: function(text){
        let resultText = text === '-'
          ? '-'
          : text == '0'
          ? '不通過'
          : text == '1'
          ? '通過'
          : '-';
        return resultText;
      },
      customCheckAction: function(item, value) {
        item.act_cnt_check_result = value == 1
        ? '通過'
        : '不通過'
      }
    },
    act_cnt_review_result: {
      type: 'text',
      label: '格式更新覆核結果',
      readonly: true,
      getText: function(text){
        let resultText = text === '-'
          ? '-'
          : text == '0'
          ? '不通過'
          : text == '1'
          ? '通過'
          : '-';
        return resultText;
      },
      customCheckAction: function(item, value) {
        item.act_cnt_review_result = value == 1
        ? '通過'
        : '不通過'
      }
    },
    act_cnt_final_review_remark: {
      type: 'textarea',
      label: '格式更新覆核備註',
      textKey: 'act_cnt_final_review_remark',
      maxlength: 1000,
    },
    idtf_check_result: {
      type: 'text',
      label: '鑑別結果',
      readonly: true,
      getText: function(text){
        let resultText = text === '-'
          ? '-'
          : text == '0'
          ? '不通過'
          : text == '1'
          ? '通過'
          : '-';
        return resultText;
      },
      customCheckAction: function(item, value) {
        item.idtf_check_result = value == 1
        ? '通過'
        : '不通過'
      }
    },
    idtf_review_result: {
      type: 'text',
      label: '鑑別覆核結果',
      getText: function(text){
        let resultText = text === '-'
          ? '-'
          : text == '0'
          ? '不通過'
          : text == '1'
          ? '通過'
          : '-';
        return resultText;
      }
    },
    idtf_final_review_remark: {
      type: 'textarea',
      label: '鑑別覆核備註',
      maxlength: 1000,
    },
    overall_review_result: {
      type: 'text',
      label: '總覆核結果',
      getText: function(text){
        let resultText = text === '-'
          ? '-'
          : text == '0'
          ? '不通過'
          : text == '1'
          ? '通過'
          : '-';
        return resultText;
      },
      customCheckAction: function(item, value) {
        item.overall_review_result = value == 1
        ? '通過'
        : '不通過'
      }
    },
    overall_review_remark: {
      type: 'textarea',
      label: '總覆核備註',
      maxlength: 1000,
    },
    btnLoading: {
      readonly: true,
      getText: () => false,
    },
    dot: {
      readonly: true,
    },
    overall_review_updated_at: {
      type: 'datetime',
      label: '總覆核編輯時間',
      readonly: true,
    },
    overall_review_updated_admin: {
      type: 'belongsTo',
      label: '總覆核編輯者',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    idtf_overall_reviewed_at: {
      type: 'datetime',
      label: '總覆核編輯時間',
      readonly: true,
    },
    idtf_overall_reviewer: {
      type: 'belongsTo',
      label: '總覆核編輯者',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    idtf_remark: {
      type: 'textarea',
      label: '鑑別備註',
      maxlength: 1000,
    },
    idtf_owners: {
      label: '鑑別負責人',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'admin',
      rules: 'required',
      width: '150px',
      clearable: true,
    },
    idtf_backups: {
      label: '鑑別備員',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'admin',
      rules: 'required',
      width: '150px',
      clearable: true,
    },
    idtf_reviewers: {
      label: '鑑別覆核人',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'admin',
      rules: 'required',
      width: '150px',
      clearable: true,
    },
    overall_owners: {
      label: '鑑別作業總負責人',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'admin',
      rules: 'required',
      width: '150px',
      clearable: true,
    },
  },
};
